import React from "react";
import axios from "axios";

const storeContext = React.createContext(null, null);
export const Consumer = storeContext.Consumer;

/**
 *
 */
export class Provider extends React.Component {

    /**
     * @param props
     */
    constructor(props) {
        super(props);
        const parameters = props.router.match.params;
        this.state = {
            loading: true,

            // Data
            slug: parameters.slug || '',
            route: props.router.match.path,
            posts: [],
            pages: [],
            media: [],
            categories: [],

            // Custom Fields
            pageFields: [],
            postFields: [],

            // Functions
            getPosts: this.getPosts,
            getPageData: this.getPageData,
            getPostData: this.getPostData,
            isNewsPost: this.isNewsPost,
            isProjectPost: this.isProjectPost
        };
    }

    /**
     *
     */
    async componentDidMount() {

        const getters = [
            this._getPages,
            this._getPosts,
            this._getMedia,
            this._getCategories,

            this._getPageFields,
            this._getPostFields
        ];

        await Promise.all(getters.map(async (f) => await f()));
        this.setState({loading: false});
    }

    /**
     * @returns {*}
     */
    render = () => (
        <storeContext.Provider value={this.state}>
            {this.props.children}
        </storeContext.Provider>
    );

    /**
     * @param filter
     * @returns {T[]}
     */
    getPosts = (filter) => {
        return this.state.posts.filter(p => this.isFilteredPost(p, filter));
    };

    /**
     * @param {{}} post
     * @param {string} filter
     * @returns {boolean}
     */
    isFilteredPost = (post, filter) => {

        let result = false;
        post.categories.forEach((id) => {
            const category = this.getCategory(id);
            if (!!category && category.slug === filter) {
                result = true;
            }
        });

        return result;
    };

    /**
     * @param id
     */
    getCategory = (id) => {
        return this.state.categories.find(c => c.id === id);
    };

    /**
     * @returns {{}|null}
     */
    getPageData = () => {
        const data = this.state.pages.find(p => p.slug === this.state.slug);
        if (!data) {
            return null;
        }

        const fields = this.state.pageFields.find(f => f.id === data.id);
        return {...data, ...fields};
    };

    /**
     * @param {string|undefined} slug
     * @returns {{}|null}
     */
    getPostData = (slug) => {
        const s = slug || this.state.slug;
        const data = this.state.posts.find(p => p.slug === s);

        if (!data) {
            return null;
        }

        const fields = this.state.postFields.find(f => f.id === data.id);
        return {...data, ...fields};
    };

    /**
     * @private
     */
    _getPosts = async () => {
        const posts = await this._get('/wp-json/wp/v2/posts');
        this.setState({posts});
    };

    /**
     * @private
     */
    _getPages = async () => {
        const pages = await this._get('/wp-json/wp/v2/pages');
        this.setState({pages});
    };

    /**
     * @private
     */
    _getPageFields = async () => {
        const pageFields = await this._get('/wp-json/acf/v3/pages');
        this.setState({pageFields});
    };

    /**
     * @private
     */
    _getPostFields = async () => {
        const postFields = await this._get('/wp-json/acf/v3/posts');
        this.setState({postFields});
    };

    /**
     * @private
     */
    _getMedia = async () => {
        const media = await this._get('/wp-json/wp/v2/media');
        this.setState({media});
    };

    /**
     * @private
     */
    _getCategories = async () => {
        const categories = await this._get('/wp-json/wp/v2/categories');
        this.setState({categories});
    };

    /**
     * @param {string} path
     * @private
     */
    _get = async (path) => {
        const response = await axios.get(path);
        return response.data;
    };
}

